// extracted by mini-css-extract-plugin
export default {"MainViewContainer":"MainViewWrapper_MainViewContainer__OKjsI"};